import { useState } from 'react';
import { useI18n } from '@/i18n';
import { ConsentDocument } from './ConsentDocument';
import './booking.css';

const ContactNotice=({text,id})=>{
  const email='allrounderound@gmail.com';
  const pieces=text.split(email);
  return <p data-testid={`${id}-contact-notice`}>{pieces.map((part,i)=><span key={i}>{i>0&&<a data-testid={`${id}-contact-email-${i}`} href={`mailto:${email}`}>{email}</a>}{part}</span>)}</p>;
};

// One component owns the checkbox + actual disabled payment button + below-button notices.
// Do not replace it with a separate CTA in any new booking or checkout page.
export const BookingAction=({consent,id,children,valid=true,busy=false,type='submit',onClick,className=''})=>{
  const {tx}=useI18n();
  const [open,setOpen]=useState(false);
  const d=consent.policy?.document;
  return <div className="booking-action" data-testid={`${id}-consent-block`}>
    {d?<>
      <p id={`${id}-scope-notice`} data-testid={`${id}-scope-notice`} className="booking-consent-scope">{d.group_notice}</p>
      <div className="booking-consent-check">
        <input id={`${id}-photo-consent`} type="checkbox" data-testid={`${id}-photo-consent`} checked={consent.checked}
          disabled={busy} onChange={e=>consent.setChecked(e.target.checked)} aria-describedby={`${id}-scope-notice`}/>
        <div><label htmlFor={`${id}-photo-consent`} data-testid={`${id}-consent-label`}>{d.checkbox}</label>
          <button type="button" className="booking-consent-view" data-testid={`${id}-consent-view`} onClick={()=>setOpen(true)}>{d.view}</button>
        </div>
      </div>
      <ConsentDocument id={id} document={d} open={open} onOpenChange={setOpen}/>
    </>:<div role="status" data-testid={`${id}-consent-loading`}>
      {consent.error?tx(consent.error):tx('Loading…')}
      {consent.error&&<button type="button" data-testid={`${id}-consent-reload`} onClick={consent.reload}>{tx('Retry')}</button>}
    </div>}
    <button type={type} disabled={busy||!valid||!consent.checked} data-testid={id}
      className={`booking-payment-button ${className}`} onClick={ev=>{if(!consent.checked||!valid||busy){ev.preventDefault();return;}onClick?.(ev);}}>{children}</button>
    <div className="booking-consent-notices">
      <p data-testid={`${id}-payment-notice`}>{d?.payment_notice||tx('온라인 결제를 진행하려면 사진·영상 촬영 및 홍보 활용에 동의해 주세요.')}</p>
      <ContactNotice text={d?.contact_notice||tx('촬영 또는 홍보 활용을 원하지 않으시면, 예약 전 allrounderound@gmail.com으로 참여 가능 여부와 촬영 제외 방법을 문의해 주세요.')} id={id}/>
    </div>
  </div>;
};